/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_DescriptionInputs */

const en_formatter_description = /** @type {(inputs: Formatter_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format and beautify JSON with proper indentation. Make your JSON human-readable instantly.`)
};

const ko_formatter_description = /** @type {(inputs: Formatter_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`적절한 들여쓰기로 JSON을 포맷하고 정리하세요. JSON을 즉시 읽기 쉽게 만듭니다.`)
};

const ja_formatter_description = /** @type {(inputs: Formatter_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`適切なインデントでJSONをフォーマット・整形。JSONを即座に読みやすくします。`)
};

/**
* | output |
* | --- |
* | "Format and beautify JSON with proper indentation. Make your JSON human-readable instantly." |
*
* @param {Formatter_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_description = /** @type {((inputs?: Formatter_DescriptionInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_DescriptionInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_description(inputs)
	if (locale === "ko") return ko_formatter_description(inputs)
	return ja_formatter_description(inputs)
});